import css from "classnames";
import * as React from "react";
import { Timer } from "./model";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    countDown: number;
}

interface State {
    time: Timer;
    seconds: number;
}

class TimeCounter extends React.Component<Props, State> {
    private timer: number;

    constructor(props: Props) {
        super(props);
        if (this.props.countDown) {
            this.state = {
                seconds: Math.floor(this.props.countDown / 1000),
                time: { hours: 0, minutes: 0, seconds: 0 }
            };
        }
        this.timer = 0;
        this.countDown = this.countDown.bind(this);
    }

    public componentDidMount() {
        if (this.props.countDown) {
            const timeLeftVar: Timer = this.secondsToTime(this.state.seconds);
            this.setState({ time: timeLeftVar });
            if (this.timer === 0) {
                setInterval(this.countDown, 1000);
            }
        }
    }
    public componentWillReceiveProps(nextProps: Props) {
        if (nextProps !== this.props) {
            const newSec = Math.floor((nextProps.countDown / 1000) % 60);
            const newTime: Timer = this.secondsToTime(newSec);
            if (newTime.minutes > 5) {
                this.setState({ time: newTime });
            }
        }
    }

    public componentWillUnmount() {
        clearInterval(this.timer);
    }

    public render(): JSX.Element {
        return (
            <section className={css(styles.timer)}>
                <div className={css(styles.row)}>
                    <div className={css(styles.square)}>
                        {this.formatTime(this.state.time.hours)}
                    </div>
                    <div className={css(styles.square)}>
                        {this.formatTime(this.state.time.minutes)}
                    </div>
                    <div className={css(styles.square)}>
                        {this.formatTime(this.state.time.seconds)}
                    </div>
                </div>
            </section>
        );
    }

    private formatTime(num: number): string {
        if (num < 10) {
            return `0${num.toString()}`;
        } else {
            return num.toString();
        }
    }

    private secondsToTime(secs: number): Timer {
        const hours = Math.floor(secs / (60 * 60));
        const minutes = Math.floor((secs % (60 * 60)) / 60);
        const seconds = Math.ceil((secs % (60 * 60)) % 60);
        return {
            hours,
            minutes,
            seconds
        };
    }

    private countDown(): void {
        // Remove one second, set state so a re-render happens.
        if (this.state.seconds) {
            const seconds = this.state.seconds - 1;
            this.setState({
                seconds,
                time: this.secondsToTime(seconds)
            });
            // Check if we're at zero.
            if (seconds === 0) {
                clearInterval(this.timer);
            }
        }
    }
}

export default TimeCounter;
